import { NgModule } from '@angular/core';
import { CwContactSupportComponent } from './contact-support.component';

@NgModule({
    imports: [],
    exports: [CwContactSupportComponent],
    declarations: [CwContactSupportComponent],
    providers: []
})
export class CwContactSupportModule {
}
